export default "/fonts/vendor/react-notifications/lib/notification.ttf?c5d9251ea82e42f753810b4ef9764720";